var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1736 -384)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(118 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25,3.271A3.271,3.271,0,0,0,21.729,0H3.271A3.271,3.271,0,0,0,0,3.271V21.729A3.271,3.271,0,0,0,3.271,25H21.729A3.271,3.271,0,0,0,25,21.729Z",
    transform: "translate(1618 385)",
    fill: "#748195"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.981 -0.933)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.568.74a.5.5,0,0,1,.864,0l6.129,10.508a.5.5,0,0,1-.432.752H.871a.5.5,0,0,1-.432-.752Z",
    transform: "translate(1635.018 390.934) rotate(90)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/play-icon.2c4a6b7fd99f907764d6a89cc999903e.svg";
export { ForwardRef as ReactComponent };